// src/components/common/DesktopHelpIcon.jsx
import React from "react";
import { View } from "@aws-amplify/ui-react";
import { Info } from "lucide-react";

export default function DesktopHelpIcon({ title }) {
  return (
    <View
      as="span"
      display={{ base: "none", large: "inline-flex" }}
      marginLeft="0.25rem"
      title={title} // native browser tooltip
    >
      <Info
        size={14}
        style={{ cursor: "help", opacity: 0.65 }}
      />
    </View>
  );
}
